import React from 'react'

import Wizard from '@modules/form-wizard'
import SERVICE_PROPS from '@helpers/extract-service-props'
import Swal from 'sweetalert2'
import { OPENMAPFIELDS } from '@modules/open-street-map-field'
import { fullName } from '@modules/form-wizard/utils'
import toastr from '@modules/toastr'


export default class ExcavateHighway extends React.Component {
  resource = '/excavate_highways'
  form_key = 'excavate_highway'
  defaults = {}

  coordinates = null

  // Delete lines as needed
  // fee = 99
  free = true
  // postpaid = true
  skip_location = true
  hide_buttons = {
    status: true,
    deny: true,
  }

  before_apply = () => {
    Swal.fire({
      title: "NOTES",
      html: `
        <style>
          @media screen and (min-width: 576px) {
            .swal2-popup {
              min-width: 85% !important;
            }
          }
          @media screen and (min-width: 768px) {
            .swal2-popup {
              min-width: 60% !important;
            }
          }
        </style>
        <div>
        <ol style="text-align: left;display: flex;flex-direction: column;gap: 1rem;">
          <li>Excavation shall not commence until all parts of the application have been approved and a copy has been transmitted 
          to the Department of Public Works for their records.</li>

          <li>Approval is granted subject to the construction and maintenance of the said works being carried out to the satisfaction 
          of the Director of Public Works.</li>

          <li>At all times when necessary, all excavations, materials, or other obstructions are to be efficiently fenced, lit and 
          watched at all times. Every possible precaution is to be taken to ensure the safety of the general public.</li>

          <li>The person or persons for whom these works are being constructed, or by whom these works are maintained, shall at 
          all times accept full responsibility for any accident that may occur or damage that may be done to any person or 
          property whatsoever, caused directly or indirectly by these works and shall save harmless and keep indemnified the 
          Ministry of Public Works and Transport from all claims and demands whatsoever in respect of the works.</li>

          <li>That this permission shall be in force only during such time as the said works are operated and maintained by the 
          applicants, to the entire satisfaction of the Director of Public Works.</li>

          <li>That the Ministry of Public Works will not be responsible for grade changes caused by the reconstruction of the 
          carriageway.</li>

          <li>This permit is valid only for the specific works herein. A separate permit must cover any alterations or additions.</li>

          <li>This permit may be cancelled, at the discretion of the Director of Public Works, without recourse, should the permittee 
          fail to comply with all the terms of the permit, thirty days notice will be given before cancellation.</li>

          <li>These works shall be identified with this permit number on all correspondence with the Ministry of Public Works.</li>
        </ol>
        </div>`,
      icon: "info",
      // customClass: {
      //   popup: ''
      // },
      confirmButtonText: "I Understand",
    });
  }

  custom_actions = [
    recommendToSeniorOfficer.call(this),
    recommendToChiefOfficer.call(this),
    finalChiefApproval.call(this),
  ]

  validate = async form => {
    const update = {}

    // Allow map component selected coordinates to translate to form latitude and longitude fields
    if(this.coordinates) {
      update.latitude = this.coordinates[0]
      update.longitude = this.coordinates[1]
    }

    return update
  }

  foremost = null

  columns = () => [
    // {
    //   name: 'BEC',
    //   selector: row => row.bec_officer ? 'Y' : 'N/A',
    //   width: '80px',
    // },
  ]

  fields = (form, formRef) => [
    ':: Part 1: Applicant Information',
    {
        name: "app_phone",
        label: "Phone #",
        type: "phone"
    },
    {
        name: "app_address",
        label: "Address",
    },
    {
        name: "app_fax",
        label: "Fax No.",
        type: 'phone',
    },
    {
      name: 'contact_first_name',
      label: 'Contact First Name',
    },
    {
      name: 'contact_middle_name',
      label: 'Contact Middle Name',
      required: false,
    },
    {
      name: 'contact_last_name',
      label: 'Contact Last Name',
    },
    {
      name: "contact_email",
      label: "Contact Email",
      type: "email"
    },
    {
      name: 'excavation_reason',
      label: 'Reason for Excavation',
      type: 'textarea',
    },
    {
      name: 'excavation_location',
      label: 'Location of Excavation',
      type: 'textarea',
    },

    ...OPENMAPFIELDS(this, form, formRef, null),

    {
      name: 'duration_of_proposed_work',
      label: 'What is the expected duration of the proposed work?',
      hint: 'In weeks or months',
    },
    {
      name: 'proposed_commencement_date',
      label: 'What is the proposed commencement date?',
      type: 'date',
      showYearDropdown: true,
    },
    {
      name: 'provided_drawing_of_proposed_work',
      label: `Has the applicant provided a drawing of the proposed works, clearly showing the traffic
              management proposals (TMP) for the duration of the contract works?`,
      type: 'select:bool',
    },
    {
      name: 'trench_reinstatement_spec',
      label: 'Does the applicant have a current copy of the Trench Reinstatement Specification?',
      type: 'select:bool',
    },

    // '::PART 2: PERMISSION TO EXCAVATE IN THE HIGHWAY (For Ministry of Works Use)',
    {
      name: 'permission_header',
      hide: true,
      view: {
        element: () => (
        <div>
          <h3>
            PART 2: PERMISSION TO EXCAVATE IN THE HIGHWAY (For Ministry of Works Use)
          </h3>
        </div>
      )}
    },
    {
      name: "location_approved",
      label: "Is the location approved?",
      type: "select:bool",
      hide: true,
      view: true
    },
    {
      name: "date_approved",
      label: "Is the date approved?",
      type: "select:bool",
      hide: true,
      view: true
    },
    {
      name: "tmp_approved",
      label: "Are Traffic Management Proposals (TMP) approved?",
      type: "select:bool",
      hide: true,
      view: true
    },
    {
      name: 'approval_conditions',
      label: 'Conditions of Approval',
      type: 'textarea',
      hide: true,
      view: true
    },

    // '::PART 3: REQUEST FOR SERVICES TO BE MARKED (For Utility Companies Use)',
    {
      name: 'utility_header',
      hide: true,
      view: {
        element: () => (
        <div>
          <h3>
            PART 3: REQUEST FOR SERVICES TO BE MARKED (For Utility Companies Use)
          </h3>
        </div>
      )}
    },
    {
      name: 'utility_header_2',
      hide: true,
      view: {
        element: () => (
        <div>
          {/* <center> */}
            <span>
              Please mark onsite the position of your services in the area of the work as noted above and provide attendance when 
              work is in progress if you consider it necessary for the adequate protection of your services. Your representative should 
              sign the Corporation's copy of this notice to indicate that all your services have been marked.            
            </span>
          {/* </center> */}
        </div>
      )}
    },
    {
      name: 'bec_officer',
      label: 'BEC Officer',
      hide: true,
      view: true
    },
    {
      name: "bec_date_list",
      label: "BEC Dates",
      columns: ['date_start', 'date_stop'],
      hide: true,
      view: true
    },

    {
      name: 'wsc_officer',
      label: 'WSC Officer',
      hide: true,
      view: true
    },
    {
      name: "wsc_date_list",
      label: "WSC Dates",
      columns: ['date_start', 'date_stop'],
      hide: true,
      view: true
    },

    {
      name: 'btc_officer',
      label: 'BTC Officer',
      hide: true,
      view: true
    },
    {
      name: "btc_date_list",
      label: "BTC Dates",
      columns: ['date_start', 'date_stop'],
      hide: true,
      view: true
    },

    {
      name: 'cable_bahamas_officer',
      label: 'Cable Bahamas Officer',
      hide: true,
      view: true
    },
    {
      name: "cable_bahamas_date_list",
      label: "Cable Bahamas Dates",
      columns: ['date_start', 'date_stop'],
      hide: true,
      view: true
    },


    // '::PART 4: NOTICE OF EXCAVATION IN THE HIGHWAY TO COMISSIONER OF POLICE (For Royal Bahamas Police Force Use)',
    {
      name: 'police_header',
      hide: true,
      view: {
        element: () => (
        <div>
          <h3>
            PART 4: NOTICE OF EXCAVATION IN THE HIGHWAY TO COMISSIONER OF POLICE (For Royal Bahamas Police Force Use)
          </h3>
        </div>
      )}
    },
    {
      name: 'police_header_2',
      hide: true,
      view: {
        element: () => (
        <div>
          {/* <center> */}
            <span>
              You are advised that the above works will be carried out as indicated. The Applicant will keep traffic disturbance to a 
              minimum but would welcome your assistance should you consider it necessary. 
            </span>
          {/* </center> */}
        </div>
      )}
    },

    {
      name: 'police_officer',
      label: 'Police Officer',
      hide: true,
      view: true
    },
    {
      name: "police_date_list",
      label: "Police Dates",
      columns: ['date_start', 'date_stop'],
      hide: true,
      view: true
    },

    "::Document Uploads",
    {
      name: "proposal_drawing_upload",
      label: "Proposal Drawing",
      type: "file:all",
      key: "image.0", 
      hint: `drawing of the proposed works, clearly showing the traffic
        management proposals (TMP)`,
      hide: !form.provided_drawing_of_proposed_work,
    },

    {
      name: "trench_spec_upload",
      label: "Trench Reinstatement specification",
      type: "file:all",
      key: "image.1",  
      hint: "Current copy of the Trench Reinstatement specification",
      required: false,
    },
  ]

  render = () => <Wizard {...SERVICE_PROPS(this)} />
}

function recommendToSeniorOfficer () {
  return {
    text: 'Forward To Sr. Officer',
    icon: 'user-tie',
    roles: ['officer'],
    test: r => ['pending'].includes(r.application_decision),
    fn: async record => {
      const { props, resource, form_key } = this
      const { history, location } = props

      const { value, isDismissed } = await Swal.fire({
        icon: 'question',
        title: 'Forward To Senior Officer',
        html: `
          What is your recommendation to the Senior Officer
          regarding the applicant,
          <strong>${fullName(record.user, 'initial')}</strong>?
        `,
        input: 'select',
        inputOptions: {
          'approved': "I recommend this applicant",
          'denied': "I do not recommend this applicant",
        },
        showCancelButton: true,
        confirmButtonText: 'Send',
      })

      if (isDismissed) return

      try {
        await $app.axios.put(resource + '/update_application', {
          [form_key]: {
            form_num: record.form_num,
            application_decision: value,
          },
        })

        if (location?.state?.view) {
          const view = { ...location.state.view }

          history.replace(location.pathname, {
            ...location.state,
            view,
          })
        }

        toastr.success('Success', 'Application successfully updated')
      } catch (error) {
        console.error(error)
        Swal.fire(
          'Oops...',
          'There has been an error with processing your application',
          'error'
        )
      }
    }
  }
}

function recommendToChiefOfficer () {
  return {
    text: 'Forward To Chief Officer',
    icon: 'user-tie',
    roles: ['senior_officer'],
    test: r => ['officer viewed'].includes(r.application_decision),
    fn: async record => {
      const { props, resource, form_key } = this
      const { history, location } = props

      const { value, isDismissed } = await Swal.fire({
        icon: 'question',
        title: 'Forward To Chief Officer',
        html: `
          What is your recommendation to the Chief Officer
          regarding the applicant,
          <strong>${fullName(record.user, 'initial')}</strong>?
        `,
        input: 'select',
        inputOptions: {
          'approved': "I recommend this applicant",
          'denied': "I do not recommend this applicant",
        },
        showCancelButton: true,
        confirmButtonText: 'Send',
      })

      if (isDismissed) return

      try {
        await $app.axios.put(resource + '/update_application', {
          [form_key]: {
            form_num: record.form_num,
            application_decision: value,
          },
        })

        if (location?.state?.view) {
          const view = { ...location.state.view }

          history.replace(location.pathname, {
            ...location.state,
            view,
          })
        }

        toastr.success('Success', 'Application successfully updated')
      } catch (error) {
        console.error(error)
        Swal.fire(
          'Oops...',
          'There has been an error with processing your application',
          'error'
        )
      }
    }
  }
}

function finalChiefApproval () {
  return {
    text: 'Approve Application',
    icon: 'user-tie',
    roles: [['chief_officer']],
    test: r => ['senior officer viewed'].includes(r.application_decision),
    fn: async record => {
      const { props, resource, form_key } = this
      const { history, location } = props

      let denial_reason = ''

      const select_modal = await Swal.fire({
        icon: 'question',
        title: 'Final Decision',
        html: `
          What is your final decision for applicant,
          <strong>${fullName(record.user, 'initial')}</strong>?
        `,
        input: 'select',
        inputOptions: {
          'approved': "I approve this applicant",
          'denied': "I deny this applicant",
        },
        showCancelButton: true,
        confirmButtonText: 'Send',
      })

      if (select_modal.isDismissed) return

      // Second modal Textarea popup if applicant denied
      if (select_modal.value == 'denied') {
        const { value, isDismissed } = await Swal.fire({
          icon: 'info',
          title: 'Reason for denial?',
          input: 'textarea',
          inputPlaceholder: 'Type your message here...',
          inputAttributes: {
              'aria-label': 'Type your message here'
          },
          showCancelButton: true,
          confirmButtonText: 'Confirm',
          backdrop: true,
          allowOutsideClick: () => !Swal.isLoading(),
        })

        if (isDismissed) return

        denial_reason = value
      }

      // console.log('values', select_modal, 'denial reason', denial_reason)

      try {
        await $app.axios.put(resource + '/update_application', {
          [form_key]: {
            form_num: record.form_num,
            application_decision: select_modal.value,
            application_decision_desc: denial_reason,
          },
        })

        if (location?.state?.view) {
          const view = { ...location.state.view }

          history.replace(location.pathname, {
            ...location.state,
            view,
          })
        }

        toastr.success('Success', 'Application successfully updated')
      } catch (error) {
        console.error(error)
        Swal.fire(
          'Oops...',
          'There has been an error with processing your application',
          'error'
        )
      }
    }
  }
}
